/*
 * @Author: chengyu
 * @Date: 2022-10-08 16:55:46
 * @Description: 高德接口请求封装
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getContextEnv, getGaoConfig } from '../config';
import { getService } from '../config/services';
import { ContextEnvEnum } from '../enums';
import { BusinessError } from '../utils/error';
import { getJsonp, getRequest } from './http';
export function aMapRequest(options) {
    var request;
    var key = options.key, url = options.url, _a = options.params, params = _a === void 0 ? {} : _a, dataType = options.dataType;
    var baseUrl = getService().GAO_DE;
    // 从config中获取默认的高德key
    var gaodeKey = getGaoConfig().key;
    var contextEnv = getContextEnv();
    var _key = key || gaodeKey;
    if (!_key) {
        throw new BusinessError('未配置高德key,高德服务不可用');
    }
    if (ContextEnvEnum.BROWSER === contextEnv && dataType === 'jsonp') {
        // 在浏览器环境中使用jsonp
        request = getJsonp();
    }
    else {
        request = getRequest();
    }
    return request.get("".concat(baseUrl).concat(url), __assign(__assign({}, params), { 
        // 如果接口，不传高德key，就使用config中的高德key
        key: _key }));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW1hcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb3JlL3JlcXVlc3QvYW1hcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHOzs7Ozs7Ozs7Ozs7QUFLSCxPQUFPLEVBQUUsYUFBYSxFQUFFLFlBQVksRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUN4RCxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sb0JBQW9CLENBQUM7QUFDaEQsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUMxQyxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0sZ0JBQWdCLENBQUM7QUFFL0MsT0FBTyxFQUFFLFFBQVEsRUFBRSxVQUFVLEVBQUUsTUFBTSxRQUFRLENBQUM7QUFvQjlDLE1BQU0sVUFBVSxXQUFXLENBQUksT0FBMkI7SUFDeEQsSUFBSSxPQUFPLENBQUM7SUFFSixJQUFBLEdBQUcsR0FBaUMsT0FBTyxJQUF4QyxFQUFFLEdBQUcsR0FBNEIsT0FBTyxJQUFuQyxFQUFFLEtBQTBCLE9BQU8sT0FBdEIsRUFBWCxNQUFNLG1CQUFHLEVBQUUsS0FBQSxFQUFFLFFBQVEsR0FBSyxPQUFPLFNBQVosQ0FBYTtJQUNwRCxJQUFNLE9BQU8sR0FBRyxVQUFVLEVBQUUsQ0FBQyxNQUFNLENBQUM7SUFDcEMscUJBQXFCO0lBQ3JCLElBQU0sUUFBUSxHQUFHLFlBQVksRUFBRSxDQUFDLEdBQUcsQ0FBQztJQUNwQyxJQUFNLFVBQVUsR0FBRyxhQUFhLEVBQUUsQ0FBQztJQUNuQyxJQUFNLElBQUksR0FBRyxHQUFHLElBQUksUUFBUSxDQUFDO0lBRTdCLElBQUksQ0FBQyxJQUFJLEVBQUU7UUFDVCxNQUFNLElBQUksYUFBYSxDQUFDLGtCQUFrQixDQUFDLENBQUM7S0FDN0M7SUFFRCxJQUFJLGNBQWMsQ0FBQyxPQUFPLEtBQUssVUFBVSxJQUFJLFFBQVEsS0FBSyxPQUFPLEVBQUU7UUFDakUsaUJBQWlCO1FBQ2pCLE9BQU8sR0FBRyxRQUFRLEVBQUUsQ0FBQztLQUN0QjtTQUFNO1FBQ0wsT0FBTyxHQUFHLFVBQVUsRUFBRSxDQUFDO0tBQ3hCO0lBRUQsT0FBTyxPQUFPLENBQUMsR0FBRyxDQUFDLFVBQUcsT0FBTyxTQUFHLEdBQUcsQ0FBRSx3QkFDaEMsTUFBTTtRQUNULGdDQUFnQztRQUNoQyxHQUFHLEVBQUUsSUFBSSxJQUNULENBQUM7QUFDTCxDQUFDIn0=